import { formConstants } from '_constants';
import { formService } from '_services';
import { alertActions } from './';
import { history } from '_helpers';

export const formActions = {
    storeForm,
    getForms,
    getForm,
    createForm,
    updateForm,
    deleteForm,
    deleteMultipleForm,
    updateFormStatus,
    getFormMessage,
    updateFormMessage,
    sendTestEmailMessage,
    findEmailTemplate,
    selectEmailTemplate,
    getAllFormGroup,
    createFormGroup,
    createFormGroupInBetween,
    findFormGroup,
    updateFormGroup,
    deleteFormGroup,
    enableFormGroup,
    reorderGroup,
    getAllFields,
    createField,
    createFieldInBetween,
    findField,
    updateField,
    deleteField,
    enableField,
    reorderField,
    getAllCustomField,
    createCustomField,
    findCustomField,
    updateCustomField,
    deleteCustomField,
    enableCustomField,
    reorderCustomField,
    findAllField,
    updateIdentifier,
    updateSubIdentifier,
    getAllFieldOption,
    createFieldOption,
    findFieldOption,
    updateFieldOption,
    deleteFieldOption,
    getAllPreset,
    createPreset,
    createPresetInBetween,
    findPreset,
    updatePreset,
    getAllTemplate,
    createTemplate,
    findTemplate,
    updateTemplate,
    getFormIntegration,
    updateFormIntegration,
    getFormAccessKey,
    getDefaultForm
};

/**
 * Stores the provided form using the formService.
 *
 * @param {object} form - The form data to be stored.
 * @returns {void} - No return value.
 */
function storeForm(form) {
  formService.storeForm(form);
}

/**
 * Retrieves the list of forms associated with a specific project.
 * Dispatches actions based on the success or failure of the request.
 *
 * @param {string} project_id - The ID of the project.
 * @returns {function} - A function that dispatches actions to fetch the forms.
 */

function getForms(project_id){
  return dispatch => {
    dispatch(request(project_id));
    formService.getForms(project_id)
      .then(
        forms => {
          dispatch(success(forms));
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request(project_id) { return { type: formConstants.GET_ALL_REQUEST, project_id } }
  function success(forms) {
  
    // ============================= //
    // let formsResponse = JSON.parse(localStorage.getItem('forms'));
    // console.log('LOCAL => forms', formsResponse);
    // ============================= //
    return { type: formConstants.GET_ALL_SUCCESS, forms }
  }
  function failure(error) { return { type: formConstants.GET_ALL_FAILURE, error } }
}

/**
 * Creates a new form for a specific project.
 * Dispatches actions based on the success or failure of the creation.
 *
 * @param {object} form - The form data to be created.
 * @param {string} project_id - The ID of the project where the form is to be created.
 * @returns {function} - A function that dispatches actions to create the form.
 */
function createForm(form, project_id) {
  return dispatch => {
    dispatch(request(form, project_id));
    formService.createForm(form, project_id)
      .then(
        form => {
          dispatch(success(form, project_id));
          dispatch(alertActions.success('Created form successfully'));
        },
        error => {
          dispatch(failure(error.toString()));
          //dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request(form) { return { type: formConstants.CREATE_REQUEST, form } }
  function success(form, project_id) {

    // ============================= //
    // let formResponse = JSON.parse(localStorage.getItem('form'));
    // console.log('LOCAL => form', formResponse);
    // let blankFormGroup = {
    //   name: "New Form Group",
    //   layout: "1"
    // };
    // ============================= //
    //formActions.createFormGroup(project_id, form.data.form_id, blankFormGroup);
    history.push(`/project/${project_id}/form/${form.data.form_id}/form-builder`);
    return { type: formConstants.CREATE_SUCCESS, form }
  }
  function failure(error) { return { type: formConstants.CREATE_FAILURE, error } }
}

/**
 * Retrieves a specific form for a given project.
 * Dispatches actions based on the success or failure of the request.
 *
 * @param {string} project_id - The ID of the project.
 * @param {string} form_id - The ID of the form to be retrieved.
 * @returns {function} - A function that dispatches actions to fetch the form.
 */
function getForm(project_id, form_id){
    return dispatch => {
        dispatch(request(project_id, form_id));
        formService.getForm(project_id, form_id)
            .then(
                form => {
                    dispatch(success(form));
                },
                error => {
                    dispatch(failure(error.toString()));
                    //dispatch(alertActions.error(form_id, error.toString()));
                }
            );
    };

    function request(form_id) { return { type: formConstants.GET_REQUEST, form_id } }
    function success(form) {
        // ============================= //
        // let formResponse = JSON.parse(localStorage.getItem('form'));
        // console.log('LOCAL => form', formResponse);
        // ============================= //
        return { type: formConstants.GET_SUCCESS, form }
    }
    function failure(error) { return { type: formConstants.GET_FAILURE, error } }
}

/**
 * Retrieves the default form for a specific project.
 * Dispatches actions based on the success or failure of the request.
 *
 * @param {string} project_id - The ID of the project.
 * @returns {function} - A function that dispatches actions to fetch the default form.
 */
function getDefaultForm(project_id){
    return dispatch => {
        dispatch(request(project_id));
        formService.getDefaultForm(project_id)
            .then(
                form => {
                    dispatch(success(form));
                },
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };

    function request(project_id) { return { type: formConstants.GET_REQUEST, project_id } }
    function success(form) {
        return { type: formConstants.GET_SUCCESS, form }
    }
    function failure(error) { return { type: formConstants.GET_FAILURE, error } }
}

/**
 * Updates a specific form in a given project.
 * Dispatches actions based on the success or failure of the update.
 *
 * @param {object} form - The form data to be updated.
 * @param {string} form_id - The ID of the form to be updated.
 * @param {string} project_id - The ID of the project where the form is located.
 * @returns {function} - A function that dispatches actions to update the form.
 */
function updateForm(form, form_id, project_id) {
  return dispatch => {
    dispatch(request(form, form_id, project_id));
    formService.updateForm(form, form_id, project_id)
      .then(
        form => {
          dispatch(success(form));
          dispatch(alertActions.success('Form updated successfully'));
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request(form) { return { type: formConstants.UPDATE_REQUEST, form } }
  function success(form) {
  
    // ============================= //
    // let formResponse = JSON.parse(localStorage.getItem('form'));
    // console.log('LOCAL => form', formResponse);
    return { type: formConstants.UPDATE_SUCCESS, form }
  }
  function failure(error) { return { type: formConstants.UPDATE_FAILURE, error } }
}

/**
 * Deletes a specific form from a given project.
 * Dispatches actions based on the success or failure of the deletion.
 * Reloads the page upon successful deletion.
 *
 * @param {object} form - The form data to be deleted.
 * @param {string} project_id - The ID of the project where the form exists.
 * @param {string} form_id - The ID of the form to be deleted.
 * @returns {function} - A function that dispatches actions to delete the form.
 */
function deleteForm(form, project_id, form_id){
  return dispatch => {
    dispatch(request(form, project_id, form_id));
    formService.deleteForm(form, project_id, form_id)
      .then(
        form => {
            // console.log('project_id actions', project_id);
          dispatch(success());
          //dispatch(alertActions.success(`Form deleted`));
          window.location.reload();
          //history.push('/project/' + project_id + '/forms');
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request(form) { return { type: formConstants.DELETE_REQUEST, form } }
  function success() {
      /*localStorage.setItem('form', JSON.stringify(form.items.data));
      let formResponse = JSON.parse(localStorage.getItem('form.items.data'));
      // console.log('form response', formResponse);*/
      return { type: formConstants.DELETE_SUCCESS } }
  function failure(error) { return { type: formConstants.DELETE_FAILURE, error } }
}

/**
 * Deletes multiple forms from a given project.
 * Dispatches actions based on the success or failure of the deletion.
 *
 * @param {object} form - The form data containing the forms to be deleted.
 * @param {string} project_id - The ID of the project from which the forms will be deleted.
 * @returns {function} - A function that dispatches actions to delete the forms.
 */
function deleteMultipleForm(form, project_id){
    return dispatch => {
        dispatch(request(form, project_id));
        formService.deleteMultipleForm(form, project_id)
            .then(
                form => {
                    dispatch(success());
                    dispatch(alertActions.success(`Forms deleted`));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(form) { return { type: formConstants.DELETE_MULTIPLE_REQUEST, form } }
    function success(form) { return { type: formConstants.DELETE_MULTIPLE_SUCCESS, form } }
    function failure(error) { return { type: formConstants.DELETE_MULTIPLE_FAILURE, error } }
}

/**
 * Updates the status of a specific form.
 * Dispatches actions based on the success or failure of the status update.
 *
 * @param {string} form_id - The ID of the form whose status is being updated.
 * @param {string} status - The new status to be applied to the form.
 * @returns {function} - A function that dispatches actions to update the form's status.
 */

function updateFormStatus(form_id, status){
    return dispatch => {
        dispatch(request(form_id, status));
        formService.updateFormStatus(form_id, status)
            .then(
                status => {
                    dispatch(success());
                    dispatch(alertActions.success(`Successfully changed status.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(status) { return {type: formConstants.UPDATE_STATUS_REQUEST,status}}
    function success(status) { return {type: formConstants.UPDATE_STATUS_SUCCESS,status}}
    function failure(error) { return {type: formConstants.UPDATE_STATUS_FAILURE, error}}
}

/**
 * Retrieves the message for a specific form in a given project.
 * Dispatches actions based on the success or failure of the request.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form whose message is being fetched.
 * @returns {function} - A function that dispatches actions to retrieve the form's message.
 */
function getFormMessage(project_id, form_id) {
  return dispatch => {
    dispatch(request(project_id, form_id));
    formService.getFormMessage(project_id, form_id)
      .then(
        message => {
          dispatch(success(message));
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(message) { return {type: formConstants.GET_MESSAGE_REQUEST, message}}
  function success(message) {
    
    // ============================= //
    //  let formMessageResponse = JSON.parse(localStorage.getItem('formMessage'));
    //  console.log('LOCAL => formMessage', formMessageResponse);
    // ============================= //
    return {type: formConstants.GET_MESSAGE_SUCCESS, message}
  }
  function failure(error) { return {type: formConstants.GET_MESSAGE_FAILURE, error}}
}

/**
 * Updates the message for a specific form in a given project.
 * Dispatches actions based on the success or failure of the update.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form whose message is being updated.
 * @param {string} message - The new message to be applied to the form.
 * @returns {function} - A function that dispatches actions to update the form's message.
 */
function updateFormMessage(project_id, form_id, message) {
    return dispatch => {
        dispatch(request(project_id, form_id, message));
        //localStorage.removeItem('formMessage');
        formService.updateFormMessage(project_id, form_id, message)
            .then(
                message => {
                    dispatch(success(message));
                    //dispatch(alertActions.success(`Successfully updated message.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    //dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(message) { return {type: formConstants.UPDATE_MESSAGE_REQUEST, message}}
    function success(message) {
      
      // ============================= //
      // let formMessageResponse = JSON.parse(localStorage.getItem('formMessage'));
      // console.log('LOCAL => formMessage', formMessageResponse);
      // ============================= //
      return {type: formConstants.UPDATE_MESSAGE_SUCCESS, message}
    }
    function failure(error) { return {type: formConstants.UPDATE_MESSAGE_FAILURE, error}}
}

/**
 * Sends a test email message for a specific form in a given project.
 * Dispatches actions based on the success or failure of the email sending.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form for which the test email is being sent.
 * @returns {function} - A function that dispatches actions to send the test email.
 */
function sendTestEmailMessage(project_id, form_id){
    return dispatch => {
        dispatch(request(project_id, form_id));
        formService.sendTestEmailMessage(project_id, form_id)
            .then(
                sendTest =>{
                    dispatch(success(sendTest));
                    dispatch(alertActions.success('Message successfully sent.'));
                },
                error => {
                  let errorMessage = '';
                  if(error.toString() === 'Error: Request failed with status code 500'){
                    errorMessage = 'Please connect your Gmail account first and try again.'
                  } else {
                    errorMessage = error.toString();
                  }
                  dispatch(failure(errorMessage));
                  dispatch(alertActions.error(errorMessage));
                }
            );
    };

    function request(project_id, form_id) { return {type: formConstants.SEND_MESSAGE_REQUEST, project_id, form_id}}
    function success(sendTest) { return {type: formConstants.SEND_MESSAGE_SUCCESS, sendTest}}
    function failure(error) { return {type: formConstants.SEND_MESSAGE_FAILURE, error}}
}

/**
 * Finds an email template for a specific form and layout in a given project.
 * Dispatches actions based on the success or failure of the request.
 *
 * @param {string} project_id - The ID of the project containing the form and layout.
 * @param {string} form_id - The ID of the form for which the email template is being fetched.
 * @param {string} layout_id - The ID of the layout for which the email template is being retrieved.
 * @returns {function} - A function that dispatches actions to find the email template.
 */
function findEmailTemplate(project_id, form_id, layout_id){
    return dispatch => {
        dispatch(request(project_id, form_id, layout_id));
        formService.findEmailTemplate(project_id, form_id, layout_id)
            .then(
                form => {
                    dispatch(success());
                    dispatch(alertActions.success(form))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(form) { return {type: formConstants.GET_LAYOUT_REQUEST, form}}
    function success(form) { return {type: formConstants.GET_LAYOUT_SUCCESS, form}}
    function failure(error) { return {type: formConstants.GET_LAYOUT_FAILURE, error}}
}

/**
 * Selects an email template for a specific form and layout in a given project.
 * Dispatches actions based on the success or failure of the selection.
 *
 * @param {string} project_id - The ID of the project containing the form and layout.
 * @param {string} form_id - The ID of the form for which the email template is being selected.
 * @param {string} layout_id - The ID of the layout for which the email template is being selected.
 * @returns {function} - A function that dispatches actions to select the email template.
 */
function selectEmailTemplate(project_id, form_id, layout_id){
    return dispatch => {
        dispatch(request(project_id, form_id, layout_id));
        formService.selectEmailTemplate(project_id, form_id, layout_id)
            .then(
                form => {
                    dispatch(success());
                    dispatch(alertActions.success(form))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(form) { return {type: formConstants.GET_LAYOUT_REQUEST, form}}
    function success(form) { return {type: formConstants.GET_LAYOUT_SUCCESS, form}}
    function failure(error) { return {type: formConstants.GET_LAYOUT_FAILURE, error}}
}

/**
 * Retrieves all form groups for a specific form in a given project.
 * Dispatches actions based on the success or failure of the request.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form for which the groups are being retrieved.
 * @returns {function} - A function that dispatches actions to get the form groups.
 */
function getAllFormGroup(project_id, form_id){
    return dispatch => {
        dispatch(request(project_id, form_id));
        formService.getAllFormGroup(project_id, form_id)
            .then(
                group => {
                    dispatch(success());
                    dispatch(alertActions.success(group))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(group) {return {type: formConstants.GET_ALL_GROUP_REQUEST, group}}
    function success(group) {return {type: formConstants.GET_ALL_GROUP_SUCCESS, group}}
    function failure(error) {return {type: formConstants.GET_ALL_GROUP_FAILURE, error}}
}

/**
 * Creates a new form group for a specific form in a given project.
 * Dispatches actions based on the success or failure of the creation.
 *
 * @param {string} project_id - The ID of the project where the form group is being created.
 * @param {string} form_id - The ID of the form to which the group is being added.
 * @param {object} group - The group data to be created.
 * @returns {function} - A function that dispatches actions to create the form group.
 */
function createFormGroup(project_id, form_id, group){
    return dispatch => {
        dispatch(request(project_id, form_id, group));
        formService.createFormGroup(project_id, form_id, group)
            .then(
                group => {
                    dispatch(success(group));
                    //dispatch(alertActions.success(`Successfully created form group.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(group) { return {type: formConstants.CREATE_FORM_GROUP_REQUEST, group}}
    function success(group) {return {type: formConstants.CREATE_FORM_GROUP_SUCCESS, group}}
    function failure(error) { return {type: formConstants.CREATE_FORM_GROUP_FAILURE, error}}
}

/**
 * Creates a new form group at a specified index in the form and reorders the form groups accordingly.
 * Dispatches actions based on the success or failure of the creation and reordering process.
 *
 * @param {string} project_id - The ID of the project where the form group is being created.
 * @param {string} form_id - The ID of the form to which the group is being added.
 * @param {object} group - The group data to be created.
 * @param {number} index - The index where the new form group should be inserted.
 * @returns {function} - A function that dispatches actions to create the form group and reorder existing groups.
 */
function createFormGroupInBetween(project_id, form_id, group, index){
  return dispatch => {
    dispatch(request(project_id, form_id, group));
    formService.createFormGroup(project_id, form_id, group)
      .then(
        group => {
          dispatch(success(group));
          // REORDER AFTER CREATING NEW GROUP
          let formData = JSON.parse(localStorage.getItem('form'));
          let formGroupData = formData.group;
          formGroupData = formGroupData.sort((a, b) => a.form_order > b.form_order);
          let newFormGroup = group.data;
          let reorder = [];

          for(let i = index - 1; i <= formGroupData.length; i++){
            let formGroupDataAllProperties = formGroupData[i];

            if(typeof formGroupDataAllProperties !== 'undefined'){
              let formGroupDataTrimmedProperties = {
                id: formGroupDataAllProperties.id,
                form_order: formGroupDataAllProperties.form_order + 1
              };
              reorder.push(formGroupDataTrimmedProperties);
            }
          }

          let newFormGroupTrimmed = {
            id: newFormGroup.id,
            form_order: parseInt(index)
          };

          reorder.push(newFormGroupTrimmed);

          let reorderData = {
            reorder: reorder
          };

          dispatch(reorderGroup(project_id, form_id, reorderData));
        },
        error => {
          dispatch(failure(error.toString()));
          //dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(group) { return {type: formConstants.CREATE_FORM_GROUP_REQUEST, group}}
  function success(group) {return {type: formConstants.CREATE_FORM_GROUP_SUCCESS, group}}
  function failure(error) { return {type: formConstants.CREATE_FORM_GROUP_FAILURE, error}}
}

/**
 * Finds a specific form group based on the provided project ID, form ID, and group ID.
 * Dispatches actions based on the success or failure of the form group retrieval process.
 *
 * @param {string} project_id - The ID of the project where the form group is located.
 * @param {string} form_id - The ID of the form containing the group.
 * @param {string} group_id - The ID of the group to retrieve.
 * @returns {function} - A function that dispatches actions to find the form group and handle the result.
 */
function findFormGroup(project_id, form_id, group_id) {
    return dispatch => {
        dispatch(request(project_id, form_id));
        formService.findFormGroup(project_id, form_id, group_id)
            .then(
                group => {
                    dispatch(success());
                    dispatch(alertActions.success(group))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(group) { return {type: formConstants.GET_GROUP_REQUEST, group}}
    function success(group) { return {type: formConstants.GET_GROUP_SUCCESS, group}}
    function failure(error) { return {type: formConstants.GET_GROUP_FAILURE, error}}
}

/**
 * Updates a specific form group with the provided group details.
 * Dispatches actions based on the success or failure of the update process.
 *
 * @param {string} project_id - The ID of the project containing the form group.
 * @param {string} form_id - The ID of the form containing the group.
 * @param {string} group_id - The ID of the form group to update.
 * @param {Object} group - The updated group data.
 * @returns {function} - A function that dispatches actions to update the form group and handle the result.
 */
function updateFormGroup(project_id, form_id, group_id, group){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, group));
        formService.updateFormGroup(project_id, form_id, group_id, group)
            .then(
                group => {
                    dispatch(success(group))
                    dispatch(alertActions.success(`Successfully updated group.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    //dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(group) {return {type: formConstants.UPDATE_GROUP_REQUEST, group}}
    function success(group) {return {type: formConstants.UPDATE_GROUP_SUCCESS, group}}
    function failure(error) {return {type: formConstants.UPDATE_GROUP_FAILURE, error}}
}

/**
 * Deletes a specific form group by its ID.
 * Dispatches actions based on the success or failure of the deletion process.
 *
 * @param {string} project_id - The ID of the project containing the form group.
 * @param {string} form_id - The ID of the form containing the group.
 * @param {string} group_id - The ID of the form group to delete.
 * @param {Object} group - The group data to delete.
 * @returns {function} - A function that dispatches actions to delete the form group and handle the result.
 */
function deleteFormGroup(project_id, form_id, group_id, group) {
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, group))
        formService.deleteFormGroup(project_id, form_id, group_id, group)
            .then(
                group => {
                    dispatch(success());
                    dispatch(alertActions.success(`Successfully deleted group`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(group) {return {type: formConstants.DELETE_GROUP_REQUEST, group}}
    function success() {return {type: formConstants.DELETE_GROUP_SUCCESS}}
    function failure(error) {return {type: formConstants.DELETE_GROUP_FAILURE, error}}
}

/**
 * Enables or disables a specific form group by updating its status.
 * Dispatches actions based on the success or failure of the status change.
 *
 * @param {string} project_id - The ID of the project containing the form group.
 * @param {string} form_id - The ID of the form containing the group.
 * @param {string} group_id - The ID of the form group to enable or disable.
 * @param {boolean} status - The status to set for the form group (e.g., `true` for enabled, `false` for disabled).
 * @returns {function} - A function that dispatches actions to update the form group's status and handle the result.
 */
function enableFormGroup(project_id, form_id, group_id, status){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, status));
        formService.enableFormGroup(project_id, form_id, group_id, status)
            .then(
                status => {
                    dispatch(success());
                    dispatch(alertActions.success(`Successfully changed status.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(status) { return {type: formConstants.UPDATE_GROUP_STATUS_REQUEST, status}}
    function success(status) { return {type: formConstants.UPDATE_GROUP_STATUS_SUCCESS, status}}
    function failure(error) { return {type: formConstants.UPDATE_GROUP_STATUS_FAILURE, error}}
}

/**
 * Reorders the form groups based on the provided order.
 * Dispatches actions based on the success or failure of the reorder operation.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form whose groups are to be reordered.
 * @param {Object} reorder - An object containing the new order for the form groups.
 * @returns {function} - A function that dispatches actions to reorder the form groups and handle the result.
 */
function reorderGroup(project_id, form_id, reorder){
    return dispatch => {
        dispatch(request(project_id, form_id, reorder));
        formService.reorderGroup(project_id, form_id, reorder)
            .then(
                reorder => {
                    dispatch(success(reorder));
                    dispatch(formActions.getForm(project_id, form_id));
                    //dispatch(alertActions.success('Successfully reordered form groups.'))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(project_id, form_id, reorder) { return {type: formConstants.REORDER_GROUP_REQUEST, reorder}}
    function success(reorder) { return {type: formConstants.REORDER_GROUP_SUCCESS, reorder}}
    function failure(error) { return {type: formConstants.REORDER_GROUP_FAILURE, error}}
}

// function getAllField(project_id, form_id, group_id){
//     return dispatch => {
//         dispatch(request(project_id, form_id, group_id));
//         formService.getAllField(project_id, form_id, group_id)
//             .then(
//                 field => {
//                     dispatch(success());
//                     dispatch(alertActions.success(field))
//                 },
//                 error => {
//                     dispatch(failure(error.toString()));
//                     dispatch(alertActions.error(error.toString()))
//                 }
//             );
//     };
//
//     function request(field) {return {type: formConstants.GET_ALL_FIELD_REQUEST, field}}
//     function success(field) {return {type: formConstants.GET_ALL_FIELD_SUCCESS, field}}
//     function failure(error) {return {type: formConstants.GET_ALL_FIELD_FAILURE, error}}
// }

/**
 * Creates a new field in a form group and dispatches actions based on the success or failure of the operation.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form where the field is to be added.
 * @param {string} group_id - The ID of the group in the form where the field will be created.
 * @param {Object} field - The data for the new field to be created.
 * @returns {function} - A function that dispatches actions to create the field and handle the result.
 */
function createField(project_id, form_id, group_id, field){
  return dispatch => {
    dispatch(request(project_id, form_id, group_id, field));
    formService.createField(project_id, form_id, group_id, field)
      .then(
        field => {
          dispatch(success(field));
          //dispatch(alertActions.success(`Successfully created form field.`))
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(field) { return {type: formConstants.CREATE_GROUP_FIELD_REQUEST, field}}
  function success(field) {
    // localStorage.setItem('field', JSON.stringify(field.data));
    // // ============================= //
    // let fieldResponse = JSON.parse(localStorage.getItem('field'));
    // console.log('LOCAL => field', fieldResponse);
    // // ============================= //
    return {type: formConstants.CREATE_GROUP_FIELD_REQUEST, field}
  }
  function failure(error) { return {type: formConstants.CREATE_GROUP_FIELD_REQUEST, error}}
}

/**
 * Creates a new field in a specific position within a form group, then reorders the fields in the group.
 * Dispatches actions based on success or failure of the operation.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form where the field is to be added.
 * @param {string} group_id - The ID of the group in the form where the field will be created.
 * @param {Object} field - The data for the new field to be created.
 * @param {number} index - The index where the new field should be inserted in the field list.
 * @param {number} totalNum - The total number of fields in the group.
 * @returns {function} - A function that dispatches actions to create the field, reorder the fields, and handle the result.
 */
function createFieldInBetween(project_id, form_id, group_id, field, index, totalNum){
  return dispatch => {
    dispatch(request(project_id, form_id, group_id, field));
    formService.createField(project_id, form_id, group_id, field)
      .then(
        field => {
          dispatch(success(field));

          // REORDER AFTER CREATING NEW FIELD
          let formData = JSON.parse(localStorage.getItem('form'));
          let formGroupData = formData.group;
          formGroupData = formGroupData.sort((a, b) => a.form_order > b.form_order);
          let formGroup = formGroupData.find(x => x.id === parseInt(group_id));
          let formFieldData = formGroup.field;
          formFieldData = formFieldData.sort((a, b) => a.form_order > b.form_order);
          let newFormField = field.data;
          let reorder = [];

          for(let i = index - 1; i <= formFieldData.length; i++){
            let formFieldDataAllProperties = formFieldData[i];

            if(typeof formFieldDataAllProperties !== 'undefined'){
              let formFieldDataTrimmedProperties = {
                id: formFieldDataAllProperties.id,
                form_order: formFieldDataAllProperties.form_order + 1
              };
              reorder.push(formFieldDataTrimmedProperties);
            }
          }

          let newFormFieldTrimmed = {
            id: newFormField.id,
            form_order: parseInt(index)
          };

          reorder.push(newFormFieldTrimmed);

          let reorderData = {
            reorder: reorder
          };

          dispatch(reorderField(project_id, form_id, group_id, reorderData));
          //dispatch(alertActions.success(`Successfully created form field.`))
        },
        error => {
          dispatch(failure(error.toString()));
          //dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(field) { return {type: formConstants.CREATE_GROUP_FIELD_REQUEST, field}}
  function success(field) {
    // localStorage.setItem('field', JSON.stringify(field.data));
    // // ============================= //
    // let fieldResponse = JSON.parse(localStorage.getItem('field'));
    // console.log('LOCAL => field', fieldResponse);
    // // ============================= //
    return {type: formConstants.CREATE_GROUP_FIELD_REQUEST, field}
  }
  function failure(error) { return {type: formConstants.CREATE_GROUP_FIELD_REQUEST, error}}
}

/**
 * Finds a specific field within a form group and dispatches actions based on the result.
 * The field is fetched from the service and, depending on the success or failure of the request,
 * an action is dispatched to update the store or show an error message.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form containing the group and field.
 * @param {string} group_id - The ID of the group containing the field.
 * @param {string} field_id - The ID of the specific field to be retrieved.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function findField(project_id, form_id, group_id, field_id) {
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id));
        formService.findField(project_id, form_id, group_id, field_id)
          .then(
            field => {
              dispatch(success(field));
              //dispatch(alertActions.success(field))
            },
            error => {
              dispatch(failure(error.toString()));
              dispatch(alertActions.error(error.toString()))
            }
          );
    };

    function request(field) { return {type: formConstants.GET_FIELD_REQUEST, field}}
    function success(field) {
      // localStorage.setItem('field', JSON.stringify(field.data));
      // // ============================= //
      // let fieldResponse = JSON.parse(localStorage.getItem('field'));
      // console.log('LOCAL => field', fieldResponse);
      // // ============================= //
      // return {type: formConstants.GET_FIELD_SUCCESS, field}
    }
    function failure(error) { return {type: formConstants.GET_FIELD_FAILURE, error}}
}

/**
 * Updates a specific field within a form group and dispatches actions based on the result.
 * The field is updated through the service and, depending on whether the request is successful or not,
 * actions are dispatched to update the store or show an error message.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form containing the group and field.
 * @param {string} group_id - The ID of the group containing the field.
 * @param {string} field_id - The ID of the field to be updated.
 * @param {object} field - The field object containing the updated data.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function updateField(project_id, form_id, group_id, field_id, field){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, field));
        formService.updateField(project_id, form_id, group_id, field_id, field)
            .then(
                field => {
                    dispatch(success(field));
                    //dispatch(alertActions.success(`Successfully updated field.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    //dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field) {return {type: formConstants.UPDATE_FIELD_REQUEST, field}}
    function success(field) {return {type: formConstants.UPDATE_FIELD_SUCCESS, field}}
    function failure(error) {return {type: formConstants.UPDATE_FIELD_FAILURE, error}}
}

/**
 * Deletes a specific field within a form group and dispatches actions based on the result.
 * The field is deleted through the service, and depending on whether the request is successful or not,
 * actions are dispatched to update the store or show an error message.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form containing the group and field.
 * @param {string} group_id - The ID of the group containing the field.
 * @param {string} field_id - The ID of the field to be deleted.
 * @param {object} field - The field object to be deleted.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function deleteField(project_id, form_id, group_id, field_id, field){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, field))
        formService.deleteField(project_id, form_id, group_id, field_id, field)
            .then(
                field => {
                    dispatch(success());
                    dispatch(alertActions.success(`Successfully deleted field`))
                },
                error => {
                    dispatch(failure(error.toString()))
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field) {return {type: formConstants.DELETE_FIELD_REQUEST, field}}
    function success(field) {return {type: formConstants.DELETE_FIELD_SUCCESS, field}}
    function failure(error) {return {type: formConstants.DELETE_FIELD_FAILURE, error}}
}

/**
 * Enables or disables a specific field within a form group by updating its status and dispatching actions accordingly.
 * This function calls the service to enable/disable the field and dispatches actions based on the success or failure of the request.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form containing the group and field.
 * @param {string} group_id - The ID of the group containing the field.
 * @param {string} field_id - The ID of the field whose status is being updated.
 * @param {boolean} status - The status to set for the field (true for enabled, false for disabled).
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function enableField(project_id, form_id, group_id, field_id, status){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, status));
        formService.enableField(project_id, form_id, group_id, field_id, status)
            .then(
                status => {
                    dispatch(success(status));
                    dispatch(alertActions.success(`Successfully changed status.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(status) { return {type: formService.UPDATE_FIELD_STATUS_REQUEST, status}}
    function success(status) { return {type: formService.UPDATE_FIELD_STATUS_SUCCESS, status}}
    function failure(error) { return {type: formService.UPDATE_FIELD_STATUS_FAILURE, error}}
}

/**
 * Reorders the fields within a specific form group and updates their order.
 * This function dispatches a request to reorder the fields and triggers a success action on completion.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form containing the group and fields.
 * @param {string} group_id - The ID of the group containing the fields to be reordered.
 * @param {Array} reorder - An array of objects representing the fields and their new order.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function reorderField(project_id, form_id, group_id, reorder){
  return dispatch => {
    dispatch(request(project_id, form_id, group_id, reorder));
    formService.reorderField(project_id, form_id, group_id, reorder)
      .then(
        reorder => {
          dispatch(success(reorder));
          dispatch(formActions.getForm(project_id, form_id));
          //dispatch(alertActions.success('Successfully reordered form fields.'))
        },
        error => {
          dispatch(failure(error.toString()));
          //dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(project_id, form_id, group_id, reorder) { return {type: formConstants.REORDER_FIELD_REQUEST, reorder}}
  function success(reorder) { return {type: formConstants.REORDER_FIELD_SUCCESS, reorder}}
  function failure(error) { return {type: formConstants.REORDER_FIELD_FAILURE, error}}
}

/**
 * Fetches all custom fields for a specific form in a given project.
 * This function dispatches a request to fetch the fields and triggers a success action on completion.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project that contains the form.
 * @param {string} form_id - The ID of the form for which the custom fields are to be fetched.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function getAllCustomField(project_id, form_id){
    return dispatch => {
        dispatch(request(project_id, form_id));
        formService.getAllCustomField(project_id, form_id)
            .then(
                field => {
                    dispatch(success());
                    dispatch(alertActions.success(field))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field) {return {type: formConstants.GET_ALL_FIELD_REQUEST, field}}
    function success(field) {return {type: formConstants.GET_ALL_FIELD_SUCCESS, field}}
    function failure(error) {return {type: formConstants.GET_ALL_FIELD_FAILURE, error}}
}

/**
 * Creates a custom field for a specific form in a given project.
 * This function dispatches a request to create the field and triggers a success action on completion.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project that contains the form.
 * @param {string} form_id - The ID of the form where the custom field will be created.
 * @param {Object} field - The field data to be created.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function createCustomField(project_id, form_id, field){
    return dispatch => {
        dispatch(request(project_id, form_id, field));
        formService.createCustomField(project_id, form_id,  field)
            .then(
                field => {
                    dispatch(success(field));
                    dispatch(alertActions.success(`Successfully created group field.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field) { return {type: formConstants.CREATE_GROUP_FIELD_REQUEST, field}}
    function success(field) {return {type: formConstants.CREATE_GROUP_FIELD_SUCCESS, field}}
    function failure(error) { return {type: formConstants.CREATE_GROUP_FIELD_FAILURE, error}}
}

/**
 * Finds a custom field within a specific form in a given project.
 * This function dispatches a request to find the field and triggers a success action upon retrieval.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form where the custom field is located.
 * @param {string} field_id - The ID of the custom field to be found.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function findCustomField(project_id, form_id, field_id){
    return dispatch => {
        dispatch(request(project_id, form_id, field_id));
        formService.findCustomField(project_id, form_id, field_id)
            .then(
                field => {
                    dispatch(success());
                    dispatch(alertActions.success(field))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field) { return {type: formConstants.GET_GROUP_REQUEST, field}}
    function success(field) { return {type: formConstants.GET_GROUP_SUCCESS, field}}
    function failure(error) { return {type: formConstants.GET_GROUP_FAILURE, error}}
}

/**
 * Updates a custom field within a specific form in a given project.
 * This function dispatches a request to update the field and triggers a success action upon successful update.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form where the custom field is located.
 * @param {string} field_id - The ID of the custom field to be updated.
 * @param {object} field - The updated data for the custom field.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function updateCustomField(project_id, form_id, field_id, field) {
    return dispatch => {
        dispatch(request(project_id, form_id, field_id, field));
        formService.updateCustomField(project_id, form_id, field_id, field)
            .then(
                field => {
                    dispatch(success(field))
                    dispatch(alertActions.success(`Successfully updated field.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field) {return {type: formConstants.UPDATE_FIELD_REQUEST, field}}
    function success(field) {return {type: formConstants.UPDATE_FIELD_SUCCESS, field}}
    function failure(error) {return {type: formConstants.UPDATE_FIELD_FAILURE, error}}
}

/**
 * Deletes a custom field from a specific form in a given project.
 * This function dispatches a request to delete the field and triggers a success action upon successful deletion.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form where the custom field is located.
 * @param {string} field_id - The ID of the custom field to be deleted.
 * @param {object} field - The custom field data to be deleted.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function deleteCustomField(project_id, form_id, field_id, field){
    return dispatch => {
        dispatch(request(project_id, form_id, field_id, field))
        formService.deleteCustomField(project_id, form_id, field_id, field)
            .then(
                field => {
                    dispatch(success());
                    dispatch(alertActions.success(`Successfully deleted field`))
                },
                error => {
                    dispatch(failure(error.toString()))
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field) {return {type: formConstants.DELETE_FIELD_REQUEST, field}}
    function success(field) {return {type: formConstants.DELETE_FIELD_SUCCESS, field}}
    function failure(error) {return {type: formConstants.DELETE_GROUP_FAILURE, error}}
}

/**
 * Enables or disables a custom field in a specific form of a project.
 * This function dispatches a request to update the field's status and triggers a success action upon successful status change.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form where the custom field is located.
 * @param {string} group_id - The ID of the group containing the custom field.
 * @param {string} field_id - The ID of the custom field whose status is to be changed.
 * @param {boolean} status - The new status of the field (e.g., `true` for enabled, `false` for disabled).
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function enableCustomField(project_id, form_id, group_id, field_id, status){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, status));
        formService.enableCustomField(project_id, form_id, group_id, field_id, status)
            .then(
                status => {
                    dispatch(success(status));
                    dispatch(alertActions.success(`Successfully changed status.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(status) { return {type: formService.UPDATE_FIELD_STATUS_REQUEST, status}}
    function success(status) { return {type: formService.UPDATE_FIELD_STATUS_SUCCESS, status}}
    function failure(error) { return {type: formService.UPDATE_FIELD_STATUS_FAILURE, error}}
}

/**
 * Reorders custom fields within a specific form of a project.
 * This function dispatches a request to reorder custom fields and triggers a success action upon successful reordering.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form where the custom fields are located.
 * @param {Array} reorder - An array representing the new order of the custom fields.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function reorderCustomField(project_id, form_id, reorder){
    return dispatch => {
        dispatch(request(project_id, form_id, reorder));
        formService.reorderCustomField(project_id, form_id, reorder)
            .then(
                reorder => {
                    dispatch(success(reorder));
                    dispatch(formActions.getForm(project_id, form_id));
                    dispatch(alertActions.success(reorder))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(reorder) { return {type: formService.REORDER_GROUP_FIELD_REQUEST, reorder}}
    function success(reorder) { return {type: formService.REORDER_GROUP_FIELD_SUCCESS, reorder}}
    function failure(error) { return {type: formService.REORDER_GROUP_FIELD_FAILURE, error}}
}

/**
 * Fetches all fields for a specific form in a project.
 * This function dispatches a request to get all fields and triggers success action upon successful retrieval.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form for which the fields are being retrieved.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function findAllField(project_id, form_id){
    return dispatch => {
        dispatch(request(project_id, form_id));
        formService.findAllField(project_id, form_id)
            .then(
                fields => {
                    dispatch(success());
                    dispatch(alertActions.success(fields))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(project_id, form_id) {return {type: formConstants.GET_ALL_FIELD_REQUEST, project_id, form_id}}
    function success(fields) {return {type: formConstants.GET_ALL_FIELD_SUCCESS, fields}}
    function failure(error) {return {type: formConstants.GET_ALL_FIELD_FAILURE, error}}
}

/**
 * Fetches all fields for a specific form within a project.
 * This function dispatches a request to get all fields and triggers a success action upon successful retrieval.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form for which the fields are being retrieved.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function getAllFields(project_id, form_id){
  return dispatch => {
    dispatch(request(project_id, form_id));
    formService.getAllFields(project_id, form_id)
      .then(
        fieldData => {
          dispatch(success(fieldData));
          dispatch(alertActions.success())
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(project_id, form_id) {return {type: formConstants.GET_ALL_FIELD_REQUEST, project_id, form_id}}
  function success(fieldData) {return {type: formConstants.GET_ALL_FIELD_SUCCESS, fieldData}}
  function failure(error) {return {type: formConstants.GET_ALL_FIELD_FAILURE, error}}
}

/**
 * Updates the primary lead field identifier for a specific form in a project.
 * This function dispatches a request to update the identifier and triggers a success action upon successful completion.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project where the form exists.
 * @param {string} form_id - The ID of the form to update the identifier for.
 * @param {Object} identifier - The new identifier object to be set as the primary lead field.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function updateIdentifier(project_id, form_id, identifier){
    return dispatch => {
        dispatch(request(project_id, form_id, identifier));
        formService.updateIdentifier(project_id, form_id, identifier)
            .then(
                form => {
                    dispatch(success(form));
                    dispatch(formActions.getForm(project_id, form_id));
                    dispatch(alertActions.success('Successfully set primary lead field.'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(project_id, form_id, identifier) {return {type: formConstants.UPDATE_FIELD_IDENTIFIER_REQUEST, project_id, form_id, identifier}}
    function success(form) {return {type: formConstants.UPDATE_FIELD_IDENTIFIER_SUCCESS, form}}
    function failure(error) {return {type: formConstants.UPDATE_FIELD_IDENTIFIER_FAILURE, error}}
}

/**
 * Updates the secondary lead field subidentifier for a specific form in a project.
 * This function dispatches a request to update the subidentifier and triggers a success action upon successful completion.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project where the form exists.
 * @param {string} form_id - The ID of the form to update the subidentifier for.
 * @param {Object} subidentifier - The new subidentifier object to be set as the secondary lead field.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function updateSubIdentifier(project_id, form_id, subidentifier){
    return dispatch => {
        dispatch(request(project_id, form_id, subidentifier));
        formService.updateSubIdentifier(project_id, form_id, subidentifier)
            .then(
              form => {
                    dispatch(success(form));
                    dispatch(formActions.getForm(project_id, form_id));
                    dispatch(alertActions.success('Successfully set secondary lead field.'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(project_id, form_id, subidentifier) {return {type: formConstants.UPDATE_FIELD_SUB_IDENTIFIER_REQUEST, project_id, form_id, subidentifier}}
    function success(form) {return {type: formConstants.UPDATE_FIELD_SUB_IDENTIFIER_SUCCESS, form}}
    function failure(error) {return {type: formConstants.UPDATE_FIELD_SUB_IDENTIFIER_FAILURE, error}}
}

/**
 * Fetches all options for a specific field in a form within a project.
 * This function dispatches a request to retrieve the field options and triggers a success action with the retrieved data.
 * If the operation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form from which to retrieve the field options.
 * @param {string} group_id - The ID of the group that contains the field.
 * @param {string} field_id - The ID of the specific field whose options need to be retrieved.
 * @returns {function} - A function that dispatches actions to request, success, or failure results.
 */
function getAllFieldOption(project_id, form_id, group_id, field_id){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id));
        formService.getAllFieldOption(project_id, form_id, group_id, field_id)
            .then(
                field_option => {
                    dispatch(success(field_option));
                    //dispatch(alertActions.success(field_option))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field_option) {return {type: formConstants.GET_ALL_OPTION_REQUEST, field_option}}
    function success(field_option) {
      // localStorage.setItem('options', JSON.stringify(field_option.data));
      // // ============================= //
      // let optionResponse = JSON.parse(localStorage.getItem('options'));
      // console.log('LOCAL => options', optionResponse);
      // // ============================= //
      return {type: formConstants.GET_ALL_OPTION_SUCCESS, field_option}
    }
    function failure(error) {return {type: formConstants.GET_ALL_OPTION_FAILURE, error}}
}

/**
 * Creates a new option for a specific field in a form within a project.
 * This function dispatches a request to create the field option, triggers a success action with the created data,
 * and updates the form state. If the creation fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form to which the field belongs.
 * @param {string} group_id - The ID of the group that contains the field.
 * @param {string} field_id - The ID of the specific field for which the option is being created.
 * @param {object} option - The option data to be created for the field.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function createFieldOption(project_id, form_id, group_id, field_id, option){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, option));
        formService.createFieldOption(project_id, form_id, group_id, field_id, option)
            .then(
                field_option => {
                    dispatch(success(field_option));
                    dispatch(formActions.getForm(project_id, form_id));
                    //dispatch(alertActions.success(`Successfully created field option.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };


    function request(field_option) { return {type: formConstants.CREATE_FIELD_OPTION_REQUEST, field_option}}
    function success(field_option) {
      localStorage.setItem('option', JSON.stringify(field_option.data));
      // ============================= //
      // let optionResponse = JSON.parse(localStorage.getItem('option'));
      // console.log('LOCAL => option', optionResponse);
      // ============================= //
      return {type: formConstants.CREATE_FIELD_OPTION_SUCCESS, field_option}
    }
    function failure(error) { return {type: formConstants.CREATE_FIELD_OPTION_FAILURE, error}}
}

/**
 * Finds a specific option for a given field in a form within a project.
 * This function dispatches a request to fetch the field option, triggers a success action with the retrieved data,
 * and stores it. If the fetch fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form that contains the field.
 * @param {string} group_id - The ID of the group that contains the field.
 * @param {string} field_id - The ID of the specific field for which the option is being fetched.
 * @param {string} option_id - The ID of the option to be retrieved.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function findFieldOption(project_id, form_id, group_id, field_id, option_id){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, option_id));
        formService.findFieldOption(project_id, form_id, group_id, field_id, option_id)
            .then(
                field_option => {
                    dispatch(success(field_option));
                    dispatch(alertActions.success());
                },
                error => {
                    dispatch(failure(error.toString()));
                    //dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(project_id, form_id, group_id, field_id, option_id) { return {type: formConstants.GET_OPTION_REQUEST, project_id, form_id, group_id, field_id, option_id}}
    function success(field_option) {
      
      // ============================= //
      // let optionResponse = JSON.parse(localStorage.getItem('option'));
      // console.log('LOCAL => option', optionResponse);
      // ============================= //
      return {type: formConstants.GET_OPTION_SUCCESS, field_option}
    }
    function failure(error) { return {type: formConstants.GET_OPTION_FAILURE, error}}
}

/**
 * Updates a specific option for a given field in a form within a project.
 * This function dispatches a request to update the field option, triggers a success action with the updated data,
 * and stores it in session storage. If the update fails, it dispatches a failure action.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form that contains the field.
 * @param {string} group_id - The ID of the group that contains the field.
 * @param {string} field_id - The ID of the specific field to which the option belongs.
 * @param {string} option_id - The ID of the option to be updated.
 * @param {Object} option - The updated option data to be saved for the field.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function updateFieldOption(project_id, form_id, group_id, field_id, option_id, option){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, option_id, option));
        formService.updateFieldOption(project_id, form_id, group_id, field_id, option_id, option)
            .then(
                field_option => {
                    dispatch(success(field_option));
                    //dispatch(alertActions.success(`Successfully updated option.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    //dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(field_option) {return {type: formConstants.UPDATE_OPTION_REQUEST, field_option}}
    function success(field_option) {
      localStorage.setItem('option', JSON.stringify(field_option.data));
      // ============================= //
      // let optionResponse = JSON.parse(localStorage.getItem('option'));
      // console.log('LOCAL => option', optionResponse);
      // ============================= //
      return {type: formConstants.UPDATE_OPTION_SUCCESS, field_option}
    }
    function failure(error) {return {type: formConstants.UPDATE_OPTION_FAILURE, error}}
}

/**
 * Deletes a specific option for a given field in a form within a project.
 * This function dispatches a request to delete the field option, triggers a success action 
 * with the updated data, and reloads the form. If the deletion fails, it dispatches a failure action
 * with an error message, including a custom error message for a 500 status code.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form that contains the field.
 * @param {string} group_id - The ID of the group that contains the field.
 * @param {string} field_id - The ID of the specific field to which the option belongs.
 * @param {string} option_id - The ID of the option to be deleted.
 * @param {Object} option - The option data to be deleted.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function deleteFieldOption(project_id, form_id, group_id, field_id, option_id, option){
    return dispatch => {
        dispatch(request(project_id, form_id, group_id, field_id, option_id, option));
        formService.deleteFieldOption(project_id, form_id, group_id, field_id, option_id, option)
            .then(
                field_option => {
                    dispatch(success());
                    dispatch(formActions.getForm(project_id, form_id));
                    dispatch(alertActions.success(`Successfully deleted option`))
                },
                error => {
                    let errorMessage = '';
                    if(error.toString() === 'Error: Request failed with status code 500'){
                      errorMessage = 'Deletion failed. Please reload the page and try again.'
                    } else {
                      errorMessage = error.toString();
                    }
                    dispatch(failure(errorMessage));
                    dispatch(alertActions.error(errorMessage));
                }
            );
    };

    function request(field_option) {return {type: formConstants.DELETE_OPTION_REQUEST, field_option}}
    function success() {return {type: formConstants.DELETE_OPTION_SUCCESS }}
    function failure(error) {return {type: formConstants.DELETE_OPTION_FAILURE, error}}
}

/**
 * Fetches all presets for a specific project and dispatches the result.
 * This function dispatches a request to retrieve presets, triggers a success action
 * if the request is successful, and dispatches an error action if the request fails.
 *
 * @param {string} project_id - The ID of the project for which presets are being fetched.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function getAllPreset(project_id){
    return dispatch => {
        dispatch(request(project_id));
        formService.getAllPreset(project_id)
            .then(
                presets => {
                    dispatch(success());
                    dispatch(alertActions.success(presets))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(presets) {return {type: formConstants.GET_ALL_PRESET_REQUEST, presets}}
    function success(presets) {return {type: formConstants.GET_ALL_PRESET_SUCCESS, presets}}
    function failure(error) {return {type: formConstants.GET_ALL_PRESET_FAILURE, error}}
}

/**
 * Creates a new preset for a specific form and project, and dispatches the result.
 * This function dispatches a request to create a new preset, triggers a success action
 * if the creation is successful, and dispatches an error action if the request fails.
 *
 * @param {string} project_id - The ID of the project where the preset is being created.
 * @param {string} form_id - The ID of the form where the preset is being applied.
 * @param {string} preset_id - The ID of the preset to be created.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function createPreset(project_id, form_id, preset_id){
    return dispatch => {
        dispatch(request(project_id, form_id, preset_id));
        formService.createPreset(project_id, form_id, preset_id)
            .then(
                presets => {
                    dispatch(success(presets));
                    dispatch(alertActions.success(`Successfully created form group.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(presets) { return {type: formConstants.CREATE_PRESET_REQUEST, presets}}
    function success(presets) {return {type: formConstants.CREATE_PRESET_SUCCESS, presets}}
    function failure(error) { return {type: formConstants.CREATE_PRESET_FAILURE, error}}
}

/**
 * Creates a new preset for a form and project, inserts it at a specific position in the form's order,
 * and dispatches the result. After creation, the form group order is recalculated to accommodate the new preset.
 *
 * @param {string} project_id - The ID of the project where the preset is being created.
 * @param {string} form_id - The ID of the form where the preset is being applied.
 * @param {string} preset_id - The ID of the preset to be created.
 * @param {number} index - The position where the new preset should be inserted in the form order.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function createPresetInBetween(project_id, form_id, preset_id, index){
  return dispatch => {
    dispatch(request(project_id, form_id, preset_id));
    formService.createPreset(project_id, form_id, preset_id)
      .then(
        presets => {
          dispatch(success(presets));
          // REORDER AFTER CREATING NEW GROUP
          let formData = JSON.parse(localStorage.getItem('form'));
          let formGroupData = formData.group;
          formGroupData = formGroupData.sort((a, b) => a.form_order > b.form_order);
          let newFormGroup = presets.data;
          let reorder = [];

          for(let i = index - 1; i <= formGroupData.length; i++){
            let formGroupDataAllProperties = formGroupData[i];

            if(typeof formGroupDataAllProperties !== 'undefined'){
              let formGroupDataTrimmedProperties = {
                id: formGroupDataAllProperties.id,
                form_order: formGroupDataAllProperties.form_order + 1
              };
              reorder.push(formGroupDataTrimmedProperties);
            }
          }

          let newFormGroupTrimmed = {
            id: newFormGroup.id,
            form_order: parseInt(index)
          };

          reorder.push(newFormGroupTrimmed);

          let reorderData = {
            reorder: reorder
          };

          dispatch(reorderGroup(project_id, form_id, reorderData));
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(presets) { return {type: formConstants.CREATE_PRESET_REQUEST, presets}}
  function success(presets) {return {type: formConstants.CREATE_PRESET_SUCCESS, presets}}
  function failure(error) { return {type: formConstants.CREATE_PRESET_FAILURE, error}}
}

/**
 * Retrieves a preset for a specific project and preset ID.
 * Dispatches success or failure based on the result of the retrieval.
 *
 * @param {string} project_id - The ID of the project to which the preset belongs.
 * @param {string} preset_id - The ID of the preset to be retrieved.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function findPreset(project_id, preset_id) {
    return dispatch => {
        dispatch(request(project_id, preset_id));
        formService.findPreset(project_id, preset_id)
            .then(
                presets => {
                    dispatch(success());
                    dispatch(alertActions.success(presets))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(presets) { return {type: formConstants.GET_PRESET_REQUEST, presets}}
    function success(presets) { return {type: formConstants.GET_PRESET_SUCCESS, presets}}
    function failure(error) { return {type: formConstants.GET_PRESET_FAILURE, error}}
}

/**
 * Updates a preset for a specific project and preset ID.
 * Dispatches success or failure based on the result of the update.
 *
 * @param {string} project_id - The ID of the project to which the preset belongs.
 * @param {string} preset_id - The ID of the preset to be updated.
 * @param {object} preset - The preset object containing the new data to update the preset with.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function updatePreset(project_id, preset_id, preset) {
    return dispatch => {
        dispatch(request(project_id, preset_id, preset));
        formService.updatePreset(project_id, preset_id, preset)
            .then(
                presets => {
                    dispatch(success(preset));
                    dispatch(alertActions.success(`Successfully updated preset.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(presets) {return {type: formConstants.UPDATE_PRESET_REQUEST, presets}}
    function success(presets) {return {type: formConstants.UPDATE_PRESET_SUCCESS, presets}}
    function failure(error) {return {type: formConstants.UPDATE_PRESET_FAILURE, error}}
}

/**
 * Retrieves all templates for a specific project.
 * Dispatches success or failure based on the result of the request.
 *
 * @param {string} project_id - The ID of the project to retrieve templates for.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function getAllTemplate(project_id){
    return dispatch => {
        dispatch(request(project_id));
        formService.getAllTemplate(project_id)
            .then(
                templates => {
                    dispatch(success());
                    dispatch(alertActions.success(templates))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(templates) {return {type: formConstants.GET_ALL_TEMPLATE_REQUEST, templates}}
    function success(templates) {return {type: formConstants.GET_ALL_TEMPLATE_SUCCESS, templates}}
    function failure(error) {return {type: formConstants.GET_ALL_TEMPLATE_FAILURE, error}}
}

/**
 * Creates a new template for a specified project.
 * Dispatches success or failure based on the result of the request.
 * Redirects to the form builder page upon successful creation.
 *
 * @param {string} project_id - The ID of the project where the template will be created.
 * @param {string} template_id - The ID of the template to be created.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function createTemplate(project_id, template_id){
    return dispatch => {
        dispatch(request(project_id, template_id));
        formService.createTemplate(project_id, template_id)
            .then(
                form => {
                    dispatch(success(form, project_id));
                    dispatch(alertActions.success(`Successfully created form.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(project_id, template_id) { return {type: formConstants.CREATE_TEMPLATE_REQUEST, project_id, template_id}}
    function success(form, project_id) {
      
      // ============================= //
      // let formResponse = JSON.parse(localStorage.getItem('form'));
      // ============================= //
      history.push(`/project/${project_id}/form/${form.data.form_id}/form-builder`);
      return {type: formConstants.CREATE_TEMPLATE_SUCCESS, form}
    }
    function failure(error) { return {type: formConstants.CREATE_TEMPLATE_FAILURE, error}}
}

/**
 * Fetches a specific template for a given project.
 * Dispatches success or failure based on the result of the request.
 *
 * @param {string} project_id - The ID of the project to fetch the template from.
 * @param {string} template_id - The ID of the template to retrieve.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function findTemplate(project_id, template_id){
    return dispatch => {
        dispatch(request(project_id, template_id));
        formService.findTemplate(project_id, template_id)
            .then(
                templates => {
                    dispatch(success());
                    dispatch(alertActions.success(templates))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(templates) { return {type: formConstants.GET_TEMPLATE_REQUEST, templates}}
    function success(templates) { return {type: formConstants.GET_TEMPLATE_SUCCESS, templates}}
    function failure(error) { return {type: formConstants.GET_TEMPLATE_FAILURE, error}}
}

/**
 * Updates an existing template for a given project.
 * Dispatches success or failure based on the result of the update.
 *
 * @param {string} project_id - The ID of the project containing the template to update.
 * @param {string} template_id - The ID of the template to update.
 * @param {Object} template - The template data to update.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function updateTemplate(project_id, template_id, template){
    return dispatch => {
        dispatch(request(project_id, template_id, template));
        formService.updateTemplate(project_id, template_id, template)
            .then(
                templates => {
                    dispatch(success(templates))
                    dispatch(alertActions.success(`Successfully updated preset.`))
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };

    function request(templates) {return {type: formConstants.UPDATE_TEMPLATE_REQUEST, templates}}
    function success(templates) {return {type: formConstants.UPDATE_TEMPLATE_SUCCESS, templates}}
    function failure(error) {return {type: formConstants.UPDATE_TEMPLATE_FAILURE, error}}
}

/**
 * Retrieves the access key for a given form within a project.
 * Dispatches success or failure based on the result of the access key retrieval.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form for which the access key is retrieved.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function getFormAccessKey(project_id, form_id) {
  return dispatch => {
    dispatch(request(project_id, form_id));
    formService.getFormAccessKey(project_id, form_id)
      .then(
        accessKey => {
          dispatch(success(accessKey));
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(project_id, form_id) { return {type: formConstants.GET_ACCESS_KEY_REQUEST, project_id, form_id}}
  function success(accessKey) {
    
    // ============================= //
    // let formAccessKeyResponse = JSON.parse(localStorage.getItem('formAccessKey'));
    // console.log('LOCAL => formAccessKey', formAccessKeyResponse);
    // ============================= //
    return {type: formConstants.GET_ACCESS_KEY_SUCCESS, accessKey}
  }
  function failure(error) { return {type: formConstants.GET_ACCESS_KEY_FAILURE, error}}
}

/**
 * Retrieves the integration settings for a given form within a project.
 * Dispatches success or failure based on the result of the integration settings retrieval.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form for which the integration settings are retrieved.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function getFormIntegration(project_id, form_id) {
  return dispatch => {
    dispatch(request(project_id, form_id));
    formService.getFormIntegration(project_id, form_id)
      .then(
        integration => {
          dispatch(success(integration));
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(project_id, form_id) { return {type: formConstants.GET_INTEGRATION_REQUEST, project_id, form_id}}
  function success(integration) {
    
    // ============================= //
    // let formIntegrationResponse = JSON.parse(localStorage.getItem('formIntegration'));
    // console.log('LOCAL => formIntegration', formIntegrationResponse);
    // ============================= //
    return {type: formConstants.GET_INTEGRATION_SUCCESS, integration}
  }
  function failure(error) { return {type: formConstants.GET_INTEGRATION_FAILURE, error}}
}

/**
 * Updates the integration settings for a specific form in a given project.
 * Removes the existing integration data from sessionStorage, updates the form integration 
 * through the form service, and reloads the page upon success.
 * Dispatches success or failure actions based on the result of the integration update.
 *
 * @param {string} project_id - The ID of the project containing the form.
 * @param {string} form_id - The ID of the form whose integration settings are being updated.
 * @param {Object} integration - The new integration settings to apply to the form.
 * @returns {function} - A function that dispatches actions for request, success, or failure results.
 */
function updateFormIntegration(project_id, form_id, integration) {
  return dispatch => {
    dispatch(request(project_id, form_id, integration));
    localStorage.removeItem('formIntegration');
    formService.updateFormIntegration(project_id, form_id, integration)
      .then(
        integration => {
          dispatch(success(integration));
          window.location.reload();
          //dispatch(alertActions.success(`Successfully updated integration.`))
        },
        error => {
          dispatch(failure(error.toString()));
          //dispatch(alertActions.error(error.toString()))
        }
      );
  };

  function request(project_id, form_id, integration) { return {type: formConstants.UPDATE_INTEGRATION_REQUEST, integration}}
  function success(integration) {
    
    // ============================= //
    // let formIntegrationResponse = JSON.parse(localStorage.getItem('formIntegration'));
    // console.log('LOCAL => formIntegration', formIntegrationResponse);
    // ============================= //
    return {type: formConstants.UPDATE_INTEGRATION_SUCCESS, integration}
  }
  function failure(error) { return {type: formConstants.UPDATE_INTEGRATION_FAILURE, error}}
}